import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { shift_pressed } from '../../keypress';
import { State } from '../../state';
import { set_smoothen_unsmoothen_selected_objects_state, smoothen_objects } from '../../uid_continuity';
import { WrappedValue } from '@phi/wrapped-value';
import BarButton from '@components/bar-button';
import smooth_svg from '../../../assets/img/SVG_icons/Top/editing_model/smoothen_edges_as_one.svg';
import { img } from '@phi/components';
import SmoothTooltip from './SmoothTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const SmoothIcon = smooth_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Smoothen objects';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_sketches
                || this.state.editing_reference_stl
                || this.current_smoothen_state === 'disabled';
        },

        current_smoothen_state() {
            this.state.selected_edges_count
                + this.state.selected_faces_count
                + this.state.selected_vertices_count;
            if (!uid_selected_vertices)
                return 'disabled';
            const wv_smoothen_state = new WrappedValue<'enabled' | 'selected' | 'disabled'>('disabled');
            const wv_unsmoothen_state = new WrappedValue<'enabled' | 'selected' | 'disabled'>('disabled');
            set_smoothen_unsmoothen_selected_objects_state(wv_smoothen_state, wv_unsmoothen_state);
            return wv_smoothen_state.v;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.current_smoothen_state === 'selected')
                smoothen_objects(shift_pressed());
            else
                smoothen_objects(shift_pressed());
        },

        onLongClick() {
            if (this.disabled)
                return;
            else if (this.current_smoothen_state === 'selected')
                smoothen_objects(true);
            else
                smoothen_objects(true);

        },
    },

    render() {
        return h(BarButton, {
            id: 'smoothen-button',
            wrapperId: 'smoothen-wrapper',
            tippy: 'left',
            long: true,
            onClick: this.onClick,
            onLongClick: this.onLongClick,
            active: this.current_smoothen_state === 'selected',
            selected: this.state.tut_stage === 8,
            disabled: this.disabled,
            help: 'smoothen_objects',
        }, {
            label: () => 'Smooth',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(smooth_svg, this.alt),
            tooltip: SmoothTooltip,
        });
    }
});
